import { FlexContainer } from '../../common/Wrappers/Containers'
import { EVMConnected } from './EVMConnected'

export const ConnectedWallets = () => (
  <FlexContainer $gap="16px">
    <EVMConnected />
  </FlexContainer>
)
